<app-left-side-nav></app-left-side-nav>
<app-header *ngIf="!isMobileDevice"></app-header>

<!-- page content area start -->
 <ng-container *ngIf="!isLoading; else loading">
  <div class="afterLoginPageContainer">
    <div class="container p-0">
      <div class="mainContent">
        <div class="select-ticket-type">
          <div
            class="py-3 px-3 d-flex justify-content-between align-items-center"
          >
            <div class="backLink" (click)="goBack()">
              <i class="fa fa-chevron-left me-3" ></i> Buy
              Tickets
            </div>
            <div class="total_amt d-flex align-items-center" *ngIf="total !== 0">
              <span class="totalkey me-2 pt-1">Total</span>
              <span class="tamount fw-bold ms-1" translate="no" >₹{{ total }}</span>
            </div>
          </div>

          <!--
          Displays a ticket section if there are unassigned tickets.
          The section uses Bootstrap flex utilities to align and space its contents.
          - *ngIf="unassignedTickets > 0": Shows the div only when there are unassigned tickets.
          - class="myTkt d-flex align-items-center justify-content-between": Applies custom and Bootstrap classes for styling and layout.
        -->
        <div *ngIf="unassignedTickets > 0" class="myTkt d-flex align-items-center justify-content-between">
          <p class="mb-0">You have not filled {{ unassignedTickets }} ticket <span
              *ngIf="unassignedTickets > 1">forms</span><span *ngIf="unassignedTickets === 1">form</span></p>
          <a class="myTktBtn" (click)="assignTickets()">Fill <span *ngIf="unassignedTickets > 1">Forms</span><span *ngIf="unassignedTickets === 1">Form</span></a>
        </div>


          <div
            class="loyalityD mb-2 d-flex justify-content-between align-items-center"
            *ngIf="loyaltyDetails?.length !== 0"
            (click)="showLoyaltyModal()"
          >
            <span class="loyaltyText" translate="no"
              ><strong> ₹{{ loyaltyDetails[0].discount_amount }}</strong>
              Loyalty Discount will be auto-applied at payment</span
            >
            <img src="/assets/images/note_icon.png" />
          </div>
          <form>
            <div class="inner-content">
              <h5 class="heading mb-2 font-weight-600">
                How many tickets do you wish to buy?
              </h5>
              <div class="ticket-list">
                <div
                  class="ticket"
                 [class.biz-pass-ticket]="ticket.code === 'biz_pass'"
                  *ngFor="
                    let ticket of ticketDetails;
                    let i = index;
                    trackBy: trackByIndex
                  "

                  (click)="
                    selectTicket($event, ticket.id, ticket.isSelected);
                    $event.stopPropagation()
                  "
                  [ngStyle]="{
                    'border': ticket.isSelected
                      ? '2px solid ' + ticketColorsModal[ticket.code].primary
                      : '',
                      'background':ticket.code === 'biz_pass'? (ticket.isSelected ? 'url(/assets/images/selected_biz.png) no-repeat center/cover' :
                      '')
                      : (ticket.isSelected
                      ? ticketColorsModal[ticket.code].secondary
                      : ''),

                    '--after-border-color':ticket.code === 'biz_pass'? (ticket.isSelected ? '#2664aa':'#2664aa') :  ticket.isSelected
                      ? ticketColorsModal[ticket.code].primary
                      : '#e5e5e5',
                    '--before-border-color':ticket.code === 'biz_pass'? (ticket.isSelected ? '#2664aa':'#2664aa') : ticket.isSelected
                      ? ticketColorsModal[ticket.code].primary
                      : '#e5e5e5'
                  }"

                >
                <div class="bizType" *ngIf="ticket.code === 'biz_pass'">
                  <img src="/assets/images/biz_logo.png" alt="Business Pass Icon"> Kisan Biz Access
              </div>
                  <div class="container text-center p-0">
                    <div class="row">
                      <div class="col-8 col-sm-8">
                        <div class="type-wrapper d-flex">
                          <h6 class="tkt-type mb-0 mt-2 font-weight-600" [ngStyle]="{ color: ticket.isSelected ? ticketColorsModal[ticket.code].primary : '#000' }" translate="no">
                            {{ ticket.name }}
                          </h6>
                          <img
                            class="tkt-icon ms-2 mt-1"
                            [src]="ticketsImagesBeforeSelecteingc[ticket.code].color"
                            alt="Ticket Icon"
                          />
                        </div>
                        <div class="price d-flex align-items-center mb-2">
                          <span class="price-text font-weight-600" translate="no"
                            >₹{{ ticket.paid_amount }}</span
                          >
                          <del class="discount-text ms-2" translate="no"
                            >₹{{ ticket.display_price }}</del
                          >

                          <span class="ms-2 discount-percent" *ngIf="ticket.code !== 'child_single_entry' && ticket.display_price !== ticket.paid_amount && ticket.display_price > 0 && ticket.paid_amount < ticket.display_price">
                            Save {{ getDiscountPercent(ticket)  | number:'1.0-0' }}% 
                          </span>
                        </div>
                      </div>
                      <div class="col-4 col-sm-4 ps-0">
                        <div
                          class="count d-flex"
                          [ngStyle]="{
                            'background-color': ticket.isSelected
                              ? ticketColorsModal[ticket.code].primary
                              : ''
                          }"
                        >
                          <button
                            class="btn minus"
                            (click)="
                              Ondecreament(ticket.id); $event.stopPropagation()
                            "
                            [ngStyle]="{
                              'border-color': ticket.isSelected
                                ? ticketColorsModal[ticket.code].primary
                                : ''
                            }"
                          >
                            <i
                              class="fa-solid fa-minus"
                              [ngStyle]="{
                                color: ticket.isSelected ? 'white' : ''
                              }"
                            ></i>
                          </button>
                          <input
                            #countInput
                            type="text"
                            class="input-style fw-bold"
                            [(ngModel)]="ticket.count"
                            name="count-{{ ticket.id }}"
                            (ngModelChange)="onChangeCount(ticket)"
                            (paste)="
                              preventNonNumericPaste($event);
                              $event.stopPropagation()
                            "
                            (keypress)="
                              allowOnlyNumbers($event); $event.stopPropagation()
                            "
                            (click)="$event.stopPropagation()"
                            (blur)="onBlurCount(ticket, countInput)"
                            min="1"
                            max="99"
                            maxlength="2"
                            [ngStyle]="{
                              'border-color': ticket.isSelected
                                ? ticketColorsModal[ticket.code].primary
                                : '',
                              color: ticket.isSelected ? '#fff' : '#000',
                              'background-color': ticket.isSelected
                                ? ticketColorsModal[ticket.code].primary
                                : ''
                            }"
                          />
                          <button
                            class="btn plus"
                            (click)="
                              Onincreament(ticket.id); $event.stopPropagation()
                            "
                            [disabled]="
                              ticket.count >= ticket.max_ticket_for_order
                            "
                            [ngClass]="{
                              'disabled-plus':
                                ticket.count >= ticket.max_ticket_for_order
                            }"
                            [ngStyle]="{
                              'border-color': ticket.isSelected
                                ? ticketColorsModal[ticket.code].primary
                                : ''
                            }"
                          >
                            <i
                              class="fa-solid fa-plus"
                              [ngStyle]="{
                                color: ticket.isSelected ? 'white' : ''
                              }"
                            ></i>
                          </button>
                        </div>
                      </div>
                    </div>


                    <div class="inst d-flex align-items-end justify-content-between">

                      <ul class="list mb-0 ps-0">

                        <li
                          class="list-item border-0 p-0"
                          [ngStyle]="{ color: ticket.isSelected ? ticketColorsModal[ticket.code].primary : '#000' }"
                          [innerHTML]="ticket.register_instructions"
                        ></li>
                      </ul>
                      <div class="knowM"
                       *ngIf="ticket.code === 'biz_pass' " 
                       data-bs-toggle="modal"
                        data-bs-target="#BizPassInfoModal"
                        
                        >
                        <i class="fa fa-circle-info"></i> 
                        <span>Know More</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="text-center mt-4">
                  <span
                    class="knowMore"
                    data-bs-toggle="modal"
                    data-bs-target="#TicketInfoModal"
                  >
                    <i class="fa fa-circle-info me-2"></i> Know more about
                    tickets</span
                  >
                </div>
              </div>
            </div>
            <div class="extra-space"></div>
            <div class="footer-btn">

              <div class="btn-wrapper">
                <button
                  type="button"
                  class="btn custom-btn-style font-weight-600"
                  [disabled]="submitBtnDisabled"
                  (click)="onClickOfSubmit()"
                >
                  Next
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
 </ng-container>

 <ng-template #loading>
  <div class="loader-container">
    <app-loader></app-loader>
  </div>
</ng-template>


<div
  class="modal fade LoyaltyDiscount"
  #loyaltyModal
  id="LoyaltyDiscountModal"
  tabindex="-1"
  aria-labelledby="LoyaltyModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content green">
      <div class="text-end">
        <button type="button" class="btn mt-2 me-2" (click)="closemodal()">
          <i class="fa-solid fa-xmark green"></i>
        </button>
      </div>
      <div class="modal-body text-center mt-3">
        <h1 class="mb-4 fw-bold">Loyalty Discount !</h1>
        <h6 class="mb-4">
          You are getting <br /><span class="amt" translate="no"
            >₹{{ loyaltyDetails[0]?.discount_amount }} </span
          ><span class="font-weight-600">Loyalty Discount<br /> </span> for
          being a loyal customer &<br />
          attending <strong>KISAN 2024</strong>.
        </h6>
        <img class="mb-3" src="/assets/images/loyalty.gif" />
        <p class="mb-4">
          The discount will be auto-applied at <br />the time of payment.
        </p>

        <button class="font-weight-600 mt-3" (click)="closemodal()">
          Okay, Thanks
        </button>
      </div>
    </div>
  </div>
</div>

<div
  #loyaltyDiscountModal
  class="modal fade LoyaltyDiscount"
  id="LoyaltyModal"
  tabindex="-1"
  aria-labelledby="LoyaltyModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content green">
      <div class="text-end">
        <button type="button" class="btn mt-2 me-2" data-bs-dismiss="modal">
          <i class="fa-solid fa-xmark green" (click)="closeLoyaltyModal()"></i>
        </button>
      </div>
      <div class="modal-body text-center mt-3">
        <h1 class="mb-4 fw-bold">Congrats!</h1>
        <h1 class="mb-0 font-weight-600">
          <span class="amt" translate="no">₹{{ loyaltyDetails[0]?.discount_amount }} </span
          ><span class="amt">Loyalty Discount<br /> </span> Applied
          Successfully.
        </h1>
        <img class="mb-3" src="/assets/images/loyalty_img.gif" />
        <p class="loyaltyDiscNote mb-4" translate="no">
          You get rs {{ loyaltyDetails[0]?.discount_amount }} loyalty discount
          for <br />
          attending Kisan 2024.
        </p>

        <button class="font-weight-600 mt-3" (click)="closeLoyaltyModal()">
          Okay, Thanks
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Ticket Information -->
<div
  class="modal fade ticketInfoModal"
  id="TicketInfoModal"
  tabindex="-1"
  aria-labelledby="TicketInfoModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-bottom modal-dialog-scrollable">
    <div class="modal-content">
      <div class="text-end">
        <button type="button" class="btn" data-bs-dismiss="modal">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>
      <div class="modal-body pt-1">
        <div class="ticketInfo">
          <h4 class="green font-weight-600">KISAN 2025 Tickets</h4>
          <p class="brf">
            Choose the right ticket for your visit to
            <span class="green">India’s Largest Agriculture Show.</span> Each
            ticket type offers different access and benefits.
          </p>

          <div class="info mt-4 d-none">
            <h4 class="type first" translate="no">
              <img class="" src="/assets/images/first_day_white.png" /> First
              Day Ticket
            </h4>
            <ul class="mb-0 ps-4">
              <li>
                Entry valid <b>only on the first day</b> of the exhibition.
              </li>
              <li>
                <b>Single entry –</b> once you exit, re-entry is not allowed.
              </li>
              <li>
                Be part of the <b>grand inauguration at 9:00 AM,</b> led by the
                <b>first group of farmers.</b>
              </li>
              <li>
                Ideal for visitors who wish to witness the opening ceremony and
                explore the show from day one.
              </li>
            </ul>
          </div>
          <div class="info mt-4">
            <h4 class="type single" translate="no"> 
              <img class="" src="/assets/images/single_entry_white.png" />
              Single Entry
            </h4>
            <ul class="mb-0 ps-4">
              <li>Valid for <b>any one day</b> of the exhibition.</li>
              <li>
                <b>Single entry –</b> once you exit, re-entry is not allowed.
              </li>
              <li>Best option if you plan to visit for just one day.</li>
            </ul>
          </div>
          <div class="info mt-4">
            <h4 class="type all" translate="no">
              <img class="" src="/assets/images/all_day_pass_white.png" /> All
              Day Pass
            </h4>
            <ul class="mb-0 ps-4">
              <li>
                Unlimited entry across <b>all 5 days</b> of the exhibition.
              </li>
              <li>Allows you to come and go freely during the event.</li>
              <li>
                Recommended for visitors who want to explore at their own pace
                and not miss any updates.
              </li>
            </ul>
          </div>
          <div class="info mt-4 d-none">
            <h4 class="type biz" translate="no">
              <img class="" src="/assets/images/business_white.png" /> Business
              Pass
            </h4>
            <ul class="mb-0 ps-4">
              <li>
                Designed for
                <b>business visitors, exhibitors, and professionals.</b>
              </li>
              <li>
                Provides all <b>5 days access</b> with unlimited entry and exit.
              </li>
              <li>
                Offers access to
                <b
                  >exclusive networking lounge, B2B meetings, KISAN Biz
                  pavilion.</b
                >
              </li>
              <li>
                Ideal for agri professionals looking to connect and collaborate.
              </li>
            </ul>
          </div>
          <div class="info mt-4">
            <h4 class="type child" translate="no">
              <img class="" src="/assets/images/child_white.png" /> Child Ticket
            </h4>
            <ul class="mb-0 ps-4">
              <li>
                Discounted ticket for children between <b>5–12 years of age.</b>
              </li>
              <li>Valid for <b>single entry on any one day.</b></li>
              <li>Children below 5 years can enter free with an adult.</li>
            </ul>
          </div>
          <p class="note mt-3">
            Note: All tickets are <b>non-transferable and non-refundable.</b>
          </p>
          <div class="extra-space"></div>
          <div class="footer-btn pb-2">
            <button
              type="button"
              data-bs-dismiss="modal"
              class="btn custom-btn-style font-weight-600"
            >
              Go Back
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- BizPass Info Modal -->
<div class="modal fade" id="BizPassInfoModal" tabindex="-1" aria-labelledby="BizPassInfoModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
          <div class="modal-body mt-3">
            <button type="button" class="btn" data-bs-dismiss="modal"><i class="fa-solid fa-xmark"></i></button>
              <div style="height: 250px;"></div>
              <div class="info">
                  <ul class="mb-3">
                      <li>Designed for <b>Business Visitors, Exhibitors and Professionals.</b></li>
                      <li>Provides <b>all 5 days access</b> with unlimited entry and exit.</li>
                      <li>Offers access to 
                          <ul>
                              <li class="font-weight-600">Exclusive Networking Lounge</li>
                              <li class="font-weight-600">B2B Meetings</li>
                              <li><b>KISAN Biz pavilion</b> ( 10-12 dec ).</li>
                          </ul>
                      </li>
                      <li>Ideal for Agri Professionals looking to Connect and Collaborate.</li>
                  </ul>
                  <p class="mb-1 ms-3">Note: All tickets are</p>
                  <p class="font-weight-600 ms-3">non-transferable and non-refundable.</p>
              </div>
          </div>
      </div>
  </div>
</div>

<!-- invitation Modal -->
<div #invitationModal class="modal" id="invitationModal" tabindex="-1" aria-labelledby="invitationModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
            <div class="inviteSec text-center">
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                <div>
                    <div class="text-center mb-3 mobile-view">
                        <img src="/assets/images/pending-icon.png" alt="invitation" width="60px" />
                    </div>
                    <h2 class="font-weight-600 mt-4">Pending Invitations</h2>

                    <p class="mb-0">
                        You have {{ inviteList.length }}
                        {{ inviteList.length === 1 ? 'invitation' : 'invitations' }}
                        pending.
                    </p>
                </div>
                <button class="acceptBtn mt-3" (click)="navigateToAcceptInvite()">View Invitation</button>
            </div>
        </div>
  </div>
</div>

